export const RESET = 'APPLICATION_LIST_RESET'
export const SET_ITEMS = 'APPLICATION_LIST_SET_ITEMS'
export const SET_ERROR = 'APPLICATION_LIST_SET_ERROR'
export const SET_VIEW = 'APPLICATION_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'APPLICATION_LIST_TOGGLE_LOADING'
export const SET_TOTAL_ITEMS = 'APPLICATION_LIST_SET_TOTAL_ITEMS'
